import { ActionContext, ActionTree, GetterTree, MutationTree } from 'vuex';
import { RootState } from './index';
import {CountryEnum} from '@/models/Enums';

export const types = {};

// Getters (GET*)
export const IS_LOADING = 'IS_LOADING';
export const GET_COUNTRY_SELECTED = `GET_COUNTRY_SELECTED`;


// Mutations (SET*, ADD*, REMOVE*)
// [ACTION]_[PROPERTY]
export const SET_LOADING = 'SET_LOADING';
export const UPDATE_COUNTRY_SELECTED = `UPDATE_COUNTRY_SELECTED`;


// Actions (FETCH*, CREATE*, UPDATE*, DELETE*)
// [ACTION]_[PROPERTY]_[STATUS]
export const DISABLE_LOADING = 'DISABLE_LOADING';
export const ENABLE_LOADING = 'ENABLE_LOADING';
export const SET_COUNTRY_SELECTED = `SET_COUNTRY_SELECTED`;


export interface State {
  version: string;
  loadingCount: number;
  countrySelected: CountryEnum;
}

export const stateRoot = (): State => ({
  version: '1.0.0',
  loadingCount: 0,
  countrySelected: CountryEnum.Brasil,
});

export const getters: GetterTree<State, RootState> = {
  [GET_COUNTRY_SELECTED](state: State): CountryEnum {
    return state.countrySelected;
  },
};

export interface Actions<S, R> extends ActionTree<S, R> {
  getVersion(context: ActionContext<S, R>): void;

  [ENABLE_LOADING](context: ActionContext<S, R>, payload: boolean): void;

  [DISABLE_LOADING](context: ActionContext<S, R>, payload: boolean): void;

  [UPDATE_COUNTRY_SELECTED](context: ActionContext<S, R>, payload: CountryEnum): void;
}

export const actions: Actions<State, RootState> = {
  async getVersion(context: ActionContext<State, RootState>) {
    return context.state.version;
  },
  [ENABLE_LOADING]: (context: ActionContext<State, RootState>, payload) => {
    context.commit(SET_LOADING, payload ? Math.abs(context.state.loadingCount) + 1 : 1);
  },
  [DISABLE_LOADING]: (context: ActionContext<State, RootState>, payload) => {
    context.commit(SET_LOADING, payload ? -context.state.loadingCount : -1);
  },
  [UPDATE_COUNTRY_SELECTED]: (context: ActionContext<State, RootState>, payload: CountryEnum) => {
    context.commit(SET_COUNTRY_SELECTED, payload, { root: true });
  },
};

export const mutations: MutationTree<State> = {
  [SET_LOADING]: (stateInner, payload) => {
    stateInner.loadingCount += payload;

    if (stateInner.loadingCount < 0) {
      stateInner.loadingCount = 0;
    }
  },
  [SET_COUNTRY_SELECTED]: (state: State, payload: CountryEnum) => {
    return state.countrySelected = payload;
  },
};
